import React from 'react';
import { Mail, Facebook, Instagram, Youtube } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { WavyDivider } from '../components/WavyDivider';
import { useSeo } from '../lib/useSeo';
import { QuoteBlock } from '../components/QuoteBlock';
export function Contact() {
  useSeo({
    title: 'Contact',
    description: "Get in touch with Branka Androjna at Milangela's Soul Garden. Connect via email, Facebook, Instagram, or YouTube.",
    path: '/contact',
    image: 'https://images.unsplash.com/photo-1521903062400-b80f2cb8cb9d?auto=format&fit=crop&q=80&w=2000'
  });
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-216">
      <Header data-id="element-217" />

      {/* Hero */}
      <section className="relative h-[85vh] min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-218">
        <div className="absolute inset-0 z-0" data-id="element-219">
          <img src="https://cdn.magicpatterns.com/uploads/pjtvKuAo9uV3etLstSEUeH/10-CONTACT-01.jpg" alt="White brick wall with pink flowers in white vases" className="w-full h-full object-cover" data-id="element-220" />
          <div className="absolute inset-0 bg-white/40" data-id="element-221"></div>
        </div>

        <div className="relative z-10 text-center px-6 mt-16" data-id="element-222">
          <h1 className="font-serif text-charcoal text-5xl md:text-6xl mb-2" data-id="element-223">
            Milangela's Soul Garden
          </h1>
          <p className="font-serif text-2xl md:text-3xl text-[#B89B72] mb-12" data-id="element-224">
            Branka Androjna
          </p>

          <p className="font-serif italic text-charcoal text-2xl mb-4" data-id="element-225">
            How to get in contact with me?
          </p>

          <a href="mailto:branka@milangelassoulgarden.com" className="inline-flex items-center gap-2 text-[#B89B72] hover:text-[#9A7D54] transition-colors mb-6" data-id="element-226">
            <span className="w-6 h-6 rounded-full border border-[#B89B72] flex items-center justify-center" data-id="element-227">
              <Mail size={12} strokeWidth={1.5} data-id="element-228" />
            </span>
            <span className="text-lg font-serif italic" data-id="element-229">
              branka@milangelassoulgarden.com
            </span>
          </a>

          <div className="flex items-center justify-center gap-6 text-[#B89B72]" data-id="element-230">
            <a href="#" className="hover:text-[#9A7D54] transition-colors text-sm tracking-wide" data-id="element-231">
              Facebook
            </a>
            <a href="#" className="hover:text-[#9A7D54] transition-colors text-sm tracking-wide" data-id="element-232">
              Instagram
            </a>
            <a href="#" className="hover:text-[#9A7D54] transition-colors text-sm tracking-wide" data-id="element-233">
              Youtube
            </a>
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none" data-id="element-234">
          <WavyDivider fill="#3A3A38" data-id="element-235" />
        </div>
      </section>

      {/* QUOTE SECTION */}
      <section className="relative bg-charcoal py-24 px-6 overflow-hidden" data-id="element-236">
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-237">
          <div className="text-6xl font-serif text-rose-300 leading-none mb-4" data-id="element-238">
            "
          </div>
          <p className="font-serif text-3xl md:text-4xl text-cream italic leading-snug mb-5" data-id="element-239">
            Trust the magic of new beginnings.
          </p>
          <p className="text-cream-100/70 text-sm tracking-widest uppercase" data-id="element-240">
            — Meister Eckhart
          </p>
        </div>
      </section>

      <Footer data-id="element-241" />
    </div>;
}